'use client';

import Image from 'next/image';
import Marquee from 'react-fast-marquee';

import { paddingClasses } from '@/app/lib/utils/getPaddingClasses';
import type { ContentfulImage } from '@/app/types/contentful/types';

import { SvgLinesComponent } from './SvgLinesComponent';

// Logo item component for marquee
const LogoItem = ({ logoData }: { logoData: ContentfulImage }) => {
  return (
    <div className="user-select-none flex-shrink-0 mx-10">
      <Image
        src={logoData.url}
        alt={logoData.description || logoData.title || 'Partner logo'}
        width={logoData.width || 150}
        height={logoData.height || 80}
        className="user-select-none h-auto max-h-[80px] w-auto max-w-[170px] object-contain md:h-[60px] md:w-[180px]"
        title={logoData.title}
        draggable={false}
      />
    </div>
  );
};

export default function LogoComponent({ content }: any) {
  const {
    logoComponent: { title, logosCollection, showGridLines, gradientType, spacingTop, spacingBottom },
  } = content;

  const paddingTop = paddingClasses.top?.[spacingTop as keyof typeof paddingClasses.top] || 'pt-4';
  const paddingBottom = paddingClasses.bottom?.[spacingBottom as keyof typeof paddingClasses.bottom] || 'pb-4';

  return (
    <section className={`relative grid h-full w-full grid-cols-12 overflow-x-clip ${paddingTop} ${paddingBottom}`}>
      {/* SVG lines container */}
      {showGridLines && <SvgLinesComponent />}

      <section className="z-10  col-span-full flex flex-col items-center text-WHITE ">
        {title && <h2 className="mb-13 text-center text-[2rem]">{title}</h2>}
        
        {/* React Fast Marquee Implementation */}
        {logosCollection?.items && logosCollection.items.length > 0 && (
          <div className="w-full">
            <Marquee
              speed={30}
              autoFill={true}
              gradient={false}
              className="pt-5"
            >
              {logosCollection.items.map((logo: ContentfulImage, index: number) => (
                <LogoItem key={`${logo.url}-${index}`} logoData={logo} />
              ))}
            </Marquee>
          </div>
        )}
      </section>

      {gradientType === 'Purple Gradient' ? (
        <div className="pointer-events-none absolute -z-10 h-full w-full select-none bg-gradient-bottom-purple bg-cover bg-bottom bg-no-repeat" />
      ) : gradientType === 'Blue Gradient' ? (
        <div className="pointer-events-none absolute -z-10 h-full w-full select-none bg-gradient-bottom-blue bg-cover bg-bottom bg-no-repeat" />
      ) : null}
    </section>
  );
}
